(function() {
  // Simple price reducer - subtract $100 from specific target products with expiration
  
  // Same target products as discount handler
  const targetProducts = ["8842421108980", "8842407051508", "8975174795508", "9090930475252", "9095649886452", "9095659815156"];
  
  // Function to check if price reduction is still valid
  function isPriceReductionValid() {
    // Set expiration date: You can modify this date as needed
    const expirationDate = new Date('2025-12-02T23:59:00-06:00');
    const currentDate = new Date();
    
    // Return true if current date is before expiration date
    return currentDate < expirationDate;
  }
  
  // Exit early if expired
  if (!isPriceReductionValid()) {
    return;
  }
  
  function extractPrice(element) {
    if (!element) return null;
    
    // Look for existing price in del tag first (original price)
    const existingOriginalPrice = element.querySelector('del');
    if (existingOriginalPrice) {
      const priceText = existingOriginalPrice.textContent.trim();
      const priceMatch = priceText.match(/\$([0-9,]+(?:\.\d{2})?)/);
      if (priceMatch && priceMatch[1]) {
        return parseFloat(priceMatch[1].replace(/,/g, ''));
      }
    }
    
    // Look for price in ins tag (current price)
    const insElement = element.querySelector('ins');
    if (insElement) {
      const priceText = insElement.textContent.trim();
      const priceMatch = priceText.match(/\$([0-9,]+(?:\.\d{2})?)/);
      if (priceMatch && priceMatch[1]) {
        return parseFloat(priceMatch[1].replace(/,/g, ''));
      }
    }
    
    // Fallback to main text content
    const mainPriceText = element.textContent.trim();
    const mainPriceMatch = mainPriceText.match(/\$([0-9,]+(?:\.\d{2})?)/);
    if (mainPriceMatch && mainPriceMatch[1]) {
      return parseFloat(mainPriceMatch[1].replace(/,/g, ''));
    }
    
    return null;
  }
  
  function formatCurrency(amount) {
    return new Intl.NumberFormat('en-US', { 
      style: 'currency', 
      currency: 'USD',
      minimumFractionDigits: 2
    }).format(amount);
  }
  
  function createPriceHTML(originalPrice, reducedPrice) {
    const formattedOriginal = formatCurrency(originalPrice);
    const formattedReduced = formatCurrency(reducedPrice);
    
    return `<del><span class="amount">${formattedOriginal}</span></del> <ins><span class="amount">${formattedReduced}</span></ins>`;
  }
  
  function reducePriceBy100(priceElement) {
    if (!priceElement) return;
    
    // Extract the current price
    const originalPrice = extractPrice(priceElement);
    
    if (!originalPrice || originalPrice <= 100) {
      return; // Skip if no price found or price is too low
    }
    
    // Reduce by $100
    const reducedPrice = originalPrice - 100;
    
    // Update the price display
    priceElement.innerHTML = createPriceHTML(originalPrice, reducedPrice);
  }
  
  function applyPriceReduction() {
    // Collect all product elements that might need processing (same as discount handler)
    const productElements = [
      // Product info price
      ...document.querySelectorAll('.product-information'),
      // Shop now
      ...document.querySelectorAll('.shopnow__product')
    ];
    
    // Process each product element
    productElements.forEach(element => {
      if (!element) return;
      
      // Get product ID (support both attribute names, same as discount handler)
      const productId = element.dataset.productId || element.dataset.actualProductId;
      
      // Only process target products
      if (targetProducts.includes(productId)) {
        // Find the price element within this product element
        const priceElement = element.querySelector('.price');
        
        if (priceElement) {
          // Apply $100 reduction to the price
          reducePriceBy100(priceElement);
        }
      }
    });
  }
  
  // Apply the price reduction when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyPriceReduction);
  } else {
    applyPriceReduction();
  }
  
  // Also apply after a short delay to catch any dynamically loaded content
  setTimeout(applyPriceReduction, 1000);
})();
